import React from "react";
import { Row, Col, Avatar, Button, Modal, Image } from 'antd';
import { withRouter } from 'react-router-dom';
import avatar from '../assets/images/avatar1.png';
import logo from '../assets/images/home/logo.png';
import miniQrcode from '../assets/images/home/mini-qrcode.jpg';
import { getCookie } from '@/utils/auth';
import balanceIcon from '../assets/images/home/balance.svg';

import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PoweroffOutlined,
} from '@ant-design/icons';
import { _loginout, _getPickupInfo } from '@/utils/api';
import { sApiStandard } from '@/utils/request';
import { connect } from 'react-redux';
import IntegrityReportModal from '../views/Home/components/integrity-report-modal';

const mapStateToProps = (state) => {
  return {contacter: state.contacter}
}

class HeaderBar extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      miniProgramModal: false,
      reportModal: false, // 新增举报弹窗控制
      merchantName: '',
    };
  }

  getPickupInfo = () => {
    _getPickupInfo().then(res => {
      const { code, data } = res;
      if (code === 200) {
        this.setState({ merchantName: data.merchantname })
      }
    })
  }

  componentDidMount() {
    this.getPickupInfo();
  }

  toggleCollapsed = () => {
    this.props.menuToggle();
  };

  navigateToShiyanjiaWeb = () => {
    sApiStandard.postData('/shiyanjia-auto-login').then(() => {
      setTimeout(() => {
        window.open(`${process.env.REACT_APP_SHIYANJIA_ORIGIN}/coupon.html`, '_blank');
      });
    })
  };

  /**
   * 退出登录
   */
  loginOut = async () => {
    try {
      await _loginout();
      let { history } = this.props
		  history.push({pathname: '/login'})
    } catch (error) {
      let { history } = this.props
		  history.push({pathname: '/login'})
    }
  }

  render() {
    const { miniProgramModal } = this.state;
    const proprietary = getCookie('proprietary');
    return (
      <>
        <Row justify="space-around" align="middle">
          <Col flex="50px">
            <Button type="text" size="large" onClick={this.toggleCollapsed}>
              {this.props.collapsed ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
            </Button>
          </Col>
          <Col flex="none" className="header-actions">
            <Button 
              type="text" 
              size="large" 
              onClick={this.navigateToShiyanjiaWeb}
              className="coupon-button"
            >
              试剂耗材优惠券
            </Button>
            <Button
              type="text"
              size="large"
              href="https://vibe-supplier.shiyanjia.com"
              target="_blank"
              rel="noopener noreferrer"
              className="coupon-button training-button"
            >
              操作培训
            </Button>
          </Col>
          <Col flex="auto" className="user">
            {proprietary !== '1' && (
              <Row
                justify="space-around"
                align="middle"
                className="minigram"
                style={{ cursor: 'pointer' }}
                onClick={() => this.setState({ reportModal: true })}
              >
                <img src={balanceIcon} alt="廉政举报" style={{ width: 15, height: 15, marginRight: 6 }} />
                <span>廉政举报</span>
              </Row>
            )}
            <Row justify="space-around" align="middle" className="minigram" onClick={() => this.setState({ miniProgramModal: true })}>
              <img className="settlement-detail-bg1" src={logo} alt='' />
              <span>科学指南针管理小程序</span>
            </Row>
            <Row justify="space-around" align="middle">
              <Avatar src={avatar} />
              <div className="user-detail">
                <div className="username">{this.state.merchantName}</div>
                <div className="welcome-tip">祝您开心每一天</div>
              </div>
            </Row>
            <div className="logout" onClick={this.loginOut}>
              <PoweroffOutlined />
              <div className="logout-text">退出</div>
            </div>
          </Col>
        </Row>
        <Modal
          title="科学指南针小程序"
          visible={miniProgramModal}
          width={500}
          onCancel={() => this.setState({ miniProgramModal: false })}
          onOk={() => this.setState({ miniProgramModal: false })}
          style={{textAlign: 'center'}}
          footer={null}
        >
          <Image width={200} src={miniQrcode} />
        </Modal>
        {/* 廉政举报弹窗 */}
        <IntegrityReportModal visible={this.state.reportModal} onClose={() => this.setState({ reportModal: false })} />

      </>
    )
  }
}

export default connect(mapStateToProps)(withRouter(HeaderBar));
